import type { DataLayerEvent } from '../../../types'
import { pushEventToDataLayer } from '../../index'

export type CloudRetailSearchParams = {
  searchQuery: string
  pageCategories?: string[]
  attributionToken?: string
  filter?: string
  orderBy?: string
  offset: number
  productIds: string[]
}

export function trackCloudRetailSearch({
  searchQuery,
  pageCategories,
  attributionToken,
  filter,
  orderBy,
  offset,
  productIds,
}: CloudRetailSearchParams): void {
  const event: DataLayerEvent = {
    event: 'cloud_retail_event',
    cloud_retail: {
      eventType: 'search',
      searchQuery,
      ...(pageCategories && { pageCategories }),
      attributionToken,
      filter,
      orderBy,
      offset,
      productDetails: productIds.map((id) => ({ product: { id } })),
    },
  }

  pushEventToDataLayer(event)
}
